<template>
  <SitePasswordGate>
    <div class="nm-page">
      <SiteNavbar />
      <main>
        <RouterView />
      </main>
      <SiteFooter />
    </div>
  </SitePasswordGate>
</template>

<script setup>
import SitePasswordGate from '@/components/SitePasswordGate.vue'
import SiteNavbar from '@/components/SiteNavbar.vue'
import SiteFooter from '@/components/SiteFooter.vue'
</script>